import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ARTICLES } from "@/data/articles";

interface ArticlesSectionProps {
  lang: string;
}

export default function ArticlesSection({ lang }: ArticlesSectionProps) {
  const { t } = useTranslation();

  return (
    <section id="articles" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold">
            {t("articles.title")}
          </h2>
          <p className="mt-3 text-foreground-600">{t("articles.subtitle")}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/${lang}/article/${a.slug}`}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden bg-background-200">
                <img
                  src={a.image}
                  alt={t(`articles.${a.slug}.title`)}
                  title={`${t(`articles.${a.slug}.title`)}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${a.icon} text-lg`}></i>
                </span>
                <h3 className="mt-4 text-base md:text-lg font-heading font-semibold leading-snug">
                  {t(`articles.${a.slug}.title`)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                  {t(`articles.${a.slug}.desc`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t("articles.readMore")}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}